/** Display-only formatting (TND). Not used for checkout totals — server returns authoritative totals. */

export function formatTnd(amount: number | null | undefined): string {
  if (amount == null || !Number.isFinite(Number(amount))) return '—'
  const n = Number(amount)
  return `${n.toFixed(3)} TND`
}
